import { createAction, createReducer } from "@reduxjs/toolkit"

const VIEW_MODE_STORAGE_KEY = "experiences:viewMode"
const VALID_VIEW_MODES = ["table", "listing"]
const DEFAULT_VIEW_MODE = "table"

const readPersistedViewMode = () => {
  try {
    const stored = localStorage.getItem(VIEW_MODE_STORAGE_KEY)
    return VALID_VIEW_MODES.includes(stored) ? stored : DEFAULT_VIEW_MODE
  } catch {
    return DEFAULT_VIEW_MODE
  }
}

const persistViewMode = (mode) => {
  try {
    localStorage.setItem(VIEW_MODE_STORAGE_KEY, mode)
  } catch {
    // localStorage may be unavailable (private mode, etc.) — fail silently
  }
}

// ACTIONS
export const setExperiencesViewMode = createAction("experiencesUi/setViewMode")

// REDUCER
const initialState = {
  viewMode: readPersistedViewMode()
}

const experiencesUiReducer = createReducer(initialState, {
  [setExperiencesViewMode.type]: (state, action) => {
    if (!VALID_VIEW_MODES.includes(action.payload)) return
    state.viewMode = action.payload
    persistViewMode(action.payload)
  }
})

export default experiencesUiReducer
